import { environment } from './environment'

export const isProduction = (): boolean => environment.ENVIRONMENT === 'prod'

export const isNonProduction = (): boolean => !isProduction()

export const isLocal = (): boolean => environment.ENVIRONMENT === 'local'
